module.exports = __webpack_public_path__ + "static/media/menu-icon.63637e94.svg";